import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { config } from "@/config/env";
import { getCurrentJWT } from "utils/tokens/tokenHelpers";

// App-wide RTK Query base. Features inject endpoints via
// clubhouseApi.injectEndpoints() rather than creating their own createApi —
// one store entry, one cache. (leaguesV2Api predates this and migrates later.)
export const clubhouseApi = createApi({
  reducerPath: "clubhouseApi",
  baseQuery: fetchBaseQuery({
    baseUrl: config.apiBaseUrl,
    prepareHeaders: (headers) => {
      const token = getCurrentJWT();
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      headers.set("Ocp-Apim-Subscription-Key", config.apimKey);
      headers.set("x-api-version", "2.0");
      return headers;
    },
  }),
  tagTypes: ["FacilityCustomers"],
  endpoints: () => ({}),
});
